export default __webpack_public_path__ + "static/media/skill_success.fc1c5f3b.svg";